import axios from "axios";
import { authHeaderJson, authHeaderFile } from "./auth-header.service";
import { API_URL, WEB_AUTH_URL } from "../configurations/paths.config"
import { getAuth, setAuth, setAuthEdit } from "../common/Helpers";

const callCookieService = () => {
  return axios.get("/api/Auth/protected-resource-cookie");
};

const callCookieService2 = () => {
  return axios.get("/api/Auth/protected-resource", {
    headers: authHeaderJson(),
  });
};

const getUser = (username) => {
  const data = JSON.stringify(username);
  const config = { method: 'post', url: `/api/user/get`, headers: authHeaderJson(), data : data };
  return axios(config);
};

const editUser = async (objUser, isCurrentUser) => {
  const response = await axios.post(`/api/user/edit`, objUser, { headers: authHeaderFile() } );

  if (response.data.succeeded) {
    if (isCurrentUser) {
        await setAuthEdit(response.data.data);
    }
  }

  return response;
};

const enableUser = (userId) => {
  return axios.post(`/api/user/enable?user_id=${userId}`, null, { headers: authHeaderJson() } );
};

const disableUser = (userId) => {
  return axios.post(`/api/user/disable?user_id=${userId}`, null, { headers: authHeaderJson() } );
};

const getUsersWithoutClient = () => {
  return axios.post(`/api/user/get-users-without-clients`, { headers: authHeaderJson() } );
};

const getUsers = (clientId, authRoleName) => {
  if (clientId === null) {
    return axios.post(`/api/user/get-all` , null, { headers: authHeaderJson() } );
  }
  else {
    return axios.post(`/api/user/get-all?clientId=${clientId}&authRoleName=${authRoleName}` , null, { headers: authHeaderJson() } );
  }
};

const getAllUsersExportExcel = (clientId, fieldList) => {
  return axios.post(`/api/client/get-users-export-excel`, { clientId: clientId, strListField: fieldList}, { headers: authHeaderJson() } );
};

const getPagedUsers = (clientId, pageNumber, pageSize, filters, orderField, orderAsc) => {
  let data = "";
  
  if (clientId === null || clientId === "00000000-0000-0000-0000-000000000000") {
    data = JSON.stringify({
      pageNumber: pageNumber,
      pageSize: pageSize,
      filters: filters,
      orderField: orderField,
      orderAsc: orderAsc
    });

    return axios.post(`/api/user/get-all` , data, { headers: authHeaderJson() } );
  }
  else {
    data = JSON.stringify({
      pageNumber: pageNumber,
      pageSize: pageSize,
      filters: filters,
      orderField: orderField,
      orderAsc: orderAsc
    });

    return axios.post(`/api/user/get-all?clientId=${clientId}` , data, { headers: authHeaderJson() } );
  }
};

const getPermission = (userName) => {
  
  const config = {
    method: 'post',
    url: `/api/user/get-permissions?userName=${userName}`,
    headers: authHeaderJson(),
    data : null
  };
  
  return axios(config);
};

const getContractAndRoleCounts = (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/user/get-count-of-contracts-and-roles`, headers: authHeaderJson(), data : data };
  
  return axios(config);
};

const getExternalLinkedAccounts = (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/user/get-external-accounts`, headers: authHeaderJson(), data : data };
  return axios(config);
};

const getExternalLinkedSimpleAccounts = async (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/user/get-external-linked-accounts`, headers: authHeaderJson(), data : data };
  return await axios(config);
};

const addLinkedAccount = async (objExternalAccount) => {
  const data = JSON.stringify(objExternalAccount);
  const config = { method: 'post', url: `/api/user/link-external-account`, headers: authHeaderJson(), data : data };
  return await axios(config);
};
const retryLinkedAccount = async (objExternalAccount) => {
  const data = JSON.stringify(objExternalAccount);
  const config = { method: 'post', url: `/api/user/retrylink-external-account`, headers: authHeaderJson(), data : data };
  return await axios(config);
};
const removeLinkedAccount = async (objExternalAccount) => {
  const data = JSON.stringify(objExternalAccount);
  const config = { method: 'post', url: `/api/user/unlink-external-account`, headers: authHeaderJson(), data : data };
  return await axios(config);
};

export default {
  getPagedUsers,
  getUsers,
  getAllUsersExportExcel,
  callCookieService,
  callCookieService2,
  getUser,
  editUser,
  disableUser,
  enableUser,
  getUsersWithoutClient,
  getPermission,
  getContractAndRoleCounts,
  getExternalLinkedAccounts,
  getExternalLinkedSimpleAccounts,
  addLinkedAccount,
  removeLinkedAccount,
  retryLinkedAccount
};